// @flow strict
/* eslint-disable no-restricted-globals */

export const mark = (name: string) => {
  // eslint-disable-next-line ta-code-conventions/lithium-string-blacklist
  if (!SERVER && window.performance && performance.mark) {
    performance.mark(name);
    // eslint-disable-next-line ta-code-conventions/lithium-string-blacklist
  } else if (SERVER && global.timing) {
    global.timing[name] = Date.now();
  }
};

// ssrTimings is passed in from the node service. It's an object containing objects for a few different metric types:
// (As of writing, the namespaces are: executeFiles (set in node service)
// and global | stage | render | serverOnlyRender | clientOnlyRender
export const logSsrMetric = (type: string, name: string, value: number) => {
  // eslint-disable-next-line ta-code-conventions/lithium-string-blacklist
  if (SERVER && global.ssrTimings) {
    if (!(type in global.ssrTimings)) {
      global.ssrTimings[type] = { [name]: value };
    } else if (name in global.ssrTimings[type]) {
      global.ssrTimings[type][name] += value;
    } else {
      global.ssrTimings[type][name] = value;
    }
  }
};

export const start = (tag: string) => {
  // eslint-disable-next-line ta-code-conventions/lithium-string-blacklist
  if (!SERVER && window.performance && performance.mark) {
    performance.mark(`components-${tag}-start`);
  }
};

export const end = (tag: string) => {
  // eslint-disable-next-line ta-code-conventions/lithium-string-blacklist
  if (!SERVER && window.performance && performance.mark && performance.measure) {
    performance.mark(`components-${tag}-end`);
    const name = `\u{1F477} ${tag}`;
    performance.measure(name, `components-${tag}-start`, `components-${tag}-end`);
  }
};
